import { BaseModel } from '../email-template/base-model.interface';
import BlockModel from '../email-template/block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface MetaVideoAccountTypeModel extends BaseModel {
  variables?: { [key: string]: string } | MetaVideoAccountTypeVariables;
}

export interface MetaVideoAccountTypeVariables {
  AccountType: string;
}

export class MetaVideoAccountTypeInitVariables implements MetaVideoAccountTypeVariables {
  AccountType = '';
}

export class MetaVideoAccountTypeInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new MetaVideoAccountTypeInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}